import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import TeamModalForm from 'modules/teams/components/TeamModalForm'
import { useCreateTeam } from 'modules/teams/hooks/useCreateTeam'
import type { TeamBasicInfo } from 'modules/teams/hooks/useTeamDetail'

const NewTeamPage: React.FC = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  track(trackingEvents.teams.createNewTeamStart)

  const { loading: creating, create } = useCreateTeam()

  const handleClose = () => {
    track(trackingEvents.teams.createNewTeamCancel)
    navigate(navigation.employees.teams.list.fullPath())
  }

  const handleOnError = (formErrors: Record<string, string>) => {
    track(trackingEvents.teams.createNewTeamSubmit, {
      is_successful: false,
      error_code: JSON.stringify(formErrors),
    })
  }

  const handleOnSuccess = (team: TeamBasicInfo) => {
    if (team) {
      track(trackingEvents.teams.createNewTeamSubmit, {
        is_successful: true,
        error_code: null,
      })
      navigate(navigation.employees.teams.id.fullPath({ id: team.id }))
    }
  }

  return (
    <TeamModalForm
      title={i18n.t('teams.add')}
      illustration="group"
      onClose={handleClose}
      onBlurName={() => track(trackingEvents.teams.createNewTeamName)}
      onBlurDescription={() => track(trackingEvents.teams.createNewTeamDescription)}
      loading={creating}
      onSubmit={create}
      onError={handleOnError}
      onSuccess={handleOnSuccess}
    />
  )
}

export default NewTeamPage
